<div *ngIf="data.isLoading">
    <app-loading></app-loading>
</div>
<div *ngIf="!data.isLoading && data.isAuthorisationRequired">
    <div mat-dialog-content class="center">
        <mat-icon class="done">done</mat-icon>
        <h3>{{'REGISTRATION.STEP.PAYMENT.DIALOG_PAYMENT.3D_SECURE'|
            translate}}</h3>
    </div>
    <div align="center" mat-dialog-actions>
        {{redirect3DSecure()}}
    </div>
</div>
<div *ngIf="!data.isLoading && data.isPaymentAuthorise">
    <div mat-dialog-content class="center">
        <mat-icon class="done">done</mat-icon>
        <h3>{{data.successMessage}}</h3>
    </div>
    <div align="center" mat-dialog-actions>
        <p>{{'REGISTRATION.STEP.PAYMENT.DIALOG_PAYMENT.CLOSE'|
                translate}}</p>
        <div>{{redirect()}}</div>
    </div>
</div>
<div *ngIf="!data.isLoading && !data.isPaymentAuthorise && !data.isAuthorisationRequired">
    <div mat-dialog-content class="center">
        <mat-icon class="fail">clear</mat-icon>
        <h3>{{'REGISTRATION.STEP.PAYMENT.DIALOG_PAYMENT.ERROR.TITLE'|
            translate}}</h3>
        <p>{{'REGISTRATION.STEP.PAYMENT.DIALOG_PAYMENT.ERROR.MESSAGE'|
            translate}}</p>
    </div>
    <div align="center" mat-dialog-actions>
        <button mat-button mat-dialog-close="fin" cdkFocusInitial>Ok</button>
    </div>
</div>
